import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { useVendorContext } from '../../context/VendorContext';

const MessageInput = ({ vendorId }) => {
  const [text, setText] = useState('');
  const { addMessage } = useVendorContext();

  const handleSend = async () => {
    if (!text.trim()) return;

    try {
      await addMessage(vendorId, {
        type: 'message',
        text: text,
        user: 'You'
      });
      setText('');
    } catch (error) {
      console.error('Failed to send message:', error);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="message-input-container">
      <input
        type="text"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder="Type a message..."
        className="message-input"
      />
      <button onClick={handleSend} className="send-button">
        <Send />
      </button>
    </div>
  );
};

export default MessageInput;